import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=58e9de84&"
import script from "./newslist.vue?vue&type=script&lang=js&"
export * from "./newslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports